import { render, staticRenderFns } from "./complaints-problem-form.pug?vue&type=template&id=4b5e68e5&lang=pug&external"
import script from "./complaints-problem-form.js?vue&type=script&lang=js&external"
export * from "./complaints-problem-form.js?vue&type=script&lang=js&external"
import style0 from "./complaints-problem-form.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports